jQuery(function ($) {
  $('a[href^="#"]').click(function () {
    var adjust = -80;
    var speed = 400;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
  $('#glimpse-slider').slick({
    autoplay: false,
    arrows: true,
    dots: true,
    speed: 300,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    variableWidth: true,
    appendDots: $('.slide01-dots'),
    prevArrow: '<div class="glimpse-slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="glimpse-slide-arrow next-arrow"></div>',
    dotsClass: 'dots-wrap',
    responsive: [
      {
        breakpoint: 768,
        slidesToShow: 1,
      },
    ],
  });
});

jQuery(function ($) {
  const $cta = $('.cta-btn-wrap');
  if (!$cta.length) return;

  const fvSelector = '.fv';
  const showOffset = 120;
  const fadeSpeed = 200;

  $cta.hide();

  function getFvBottom() {
    const $fv = $(fvSelector);
    return $fv.length
      ? $fv.offset().top + $fv.outerHeight()
      : $(window).height();
  }

  function isAtBottom() {
    return (
      $(window).scrollTop() + $(window).height() >=
      $(document).height() - 1
    );
  }

  function updateCTA() {
    const scrollTop = $(window).scrollTop();
    const shouldHide =
      scrollTop < getFvBottom() + showOffset || isAtBottom();

    if (shouldHide) {
      if ($cta.is(':visible')) {
        $cta.stop(true, true).fadeOut(fadeSpeed);
      }
    } else {
      if (!$cta.is(':visible')) {
        $cta.stop(true, true).fadeIn(fadeSpeed);
      }
    }
  }

  $(window).on('scroll resize', updateCTA);
  updateCTA();
});

jQuery(function ($) {
  $('.faq-answer').hide();

  $('.faq-question').on('click', function () {
    const $item = $(this).closest('.faq-item');
    const $answer = $item.find('.faq-answer');
    const $text = $(this).find('.arrow-text');

    if ($item.hasClass('is-open')) {
      $item.removeClass('is-open');
      $answer.stop(true, true).slideUp(200);
      $text.text('OPEN');
    } else {
      $item.addClass('is-open');
      $answer.stop(true, true).slideDown(200);
      $text.text('CLOSE');
    }
  });
});